import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../../global/globals';

export interface ChipType {
  id?: number;
  name: string;
  code: string;
}

@Injectable({ providedIn: 'root' })
export class ChipTypeService {
  private baseUrl: string;

  constructor(private http: HttpClient, private globals: Globals) {
    this.baseUrl = this.globals.backendUri + '/chip-type';
  }

  getAll(): Observable<ChipType[]> {
    return this.http.get<ChipType[]>(this.baseUrl);
  }

  getById(id: number): Observable<ChipType> {
    return this.http.get<ChipType>(`${this.baseUrl}/${id}`);
  }

  create(chipType: ChipType): Observable<ChipType> {
    return this.http.post<ChipType>(this.baseUrl, chipType);
  }

  update(id: number, chipType: ChipType): Observable<ChipType> {
    return this.http.put<ChipType>(`${this.baseUrl}/${id}`, chipType);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
